/**
 * Theme provider.
 *
 * The provider has no context of its own: the theme is *state* that lives in the UI store and *output* that lives on
 * the document element. Wrapping it in React context would create a third source of truth for the same fact, so the
 * provider only performs the side effect.
 */

import { useAppliedTheme } from '@/hooks/useTheme';

/** Props accepted by {@link ThemeProvider}. */
export interface ThemeProviderProps {
  /** Subtree that renders inside the theme. */
  children: React.ReactNode;
}

/** Applies the resolved colour scheme to the document element. */
export function ThemeProvider({ children }: ThemeProviderProps) {
  useAppliedTheme();

  return <>{children}</>;
}
